import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import SharePointConfig from './SharePointConfig';

/**
 * System Admin: edit SharePoint configuration for another identity user (by email in path).
 */
export default function AdminSharePointConfigRoute() {
  const { email } = useParams();
  const location = useLocation();
  const decoded = email ? decodeURIComponent(email) : '';
  const displayName = location.state && location.state.displayName
    ? String(location.state.displayName).trim()
    : '';

  return (
    <SharePointConfig
      configOwnerEmail={decoded}
      configOwnerDisplayName={displayName}
    />
  );
}
